import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DetDigitaleFort from "./sections/DetDigitaleFort";
import OurManifesto from "./sections/OurManifesto";
import KampenForDeUfodte from "./sections/KampenForDeUfodte";
import DisciplinOgKarakter from "./sections/DisciplinOgKarakter";
import SenesteFraFrontlinjen from "./sections/SenesteFraFrontlinjen";
import MoralskGenopbygning from "./sections/MoralskGenopbygning";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <DetDigitaleFort />
      <OurManifesto />
      <KampenForDeUfodte />
      <DisciplinOgKarakter />
      <SenesteFraFrontlinjen />
      <MoralskGenopbygning />
      <Footer />
    </div>;
}